import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Modal, Upload, message } from 'antd';
import PropTypes from 'prop-types';//props传参检查库
import SignatureCanvas from 'react-signature-canvas';
import { Config } from '../../public/js/config';
import { PlusOutlined } from '@ant-design/icons';

import './signModal.css'

import  trans  from './translation';

const { TabPane } = Tabs;
const SignModal = (props) => {

    const [tabIndex, setTabIndex] = useState("1");
    const imageNum = 1;
    const [isShow, setIsShow] = useState(true);
    const signatureCanvasRef = useRef(null);
    const [imageFile, setImageFile] = useState([]);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [language, setLanguage] = useState(props.language);
    const [signatureImg, setSignatureImg] = useState(props.signatureImg);

    useEffect(() => {
    }, []);

    const clearSignature = () => {
        if (signatureCanvasRef.current) {
            signatureCanvasRef.current.clear();
        }
        setImageFile([]);
        props.onClose();
    };

    const clear = () => {
        if (signatureCanvasRef.current) {
            signatureCanvasRef.current.clear();
        }
    };

    const saveSignature = () => {
        if (signatureCanvasRef.current.isEmpty()) {
            message.error(trans.signatureImgIsRequired[language])
            return;
        }
        if (signatureCanvasRef.current) {
            const dataUrl = signatureCanvasRef.current.toDataURL();
            props.onClose(dataUrl);
        }
    };

    const saveSignature3 = () => {
        if (imageFile.length <= 0) {
            message.error(trans.signatureImgIsRequired[language])
            return;
        }
        if (imageFile.length > 0) {
            const reader = new FileReader();
            reader.readAsDataURL(imageFile[0].originFileObj);
            reader.onload = (e) => {
                imageFile[0].originUrl = e.target.result;
                imageFile[0].imgStatus = "NEW";
                props.onClose(imageFile[0]?.originUrl);
            }
        }
    }

    const handleSelect = (key) => {
        if (key) {
            if (key == "1") {
                setImageFile([]);
            } else if (key == "3") {
                if (signatureCanvasRef.current) {
                    signatureCanvasRef.current.clear();
                }
            }
            setTabIndex(key);
        }
    }

    const handleChange = (file) => {
        let fileList = file.fileList;
        file = file.file;
        if (file.status === "removed") {
            let index = imageFile.findIndex(item => item.uid == file.uid);
            let fileList = JSON.parse(JSON.stringify(imageFile));
            fileList.splice(index, 1)
        } else if (file.status === "uploading") {
            setImageFile(fileList);
            return
        } else if (file.status === "error") {
            message.error(file.error.message);
        } else if (file?.response?.error) {
            message.error(file.response.error?.message);
        }
        setImageFile(fileList.filter(item => (item.status === 'done' && !item.response.error) || item.status === 'old'));
    }

    const handleCancel = () => {
        setPreviewVisible(false);
    }

    const handlePreview = (file) => {
        setPreviewImage(file.url || file.thumbUrl);
        setPreviewVisible(true);
    }

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div>Upload Photo</div>
        </div>
    );

    return (
        <Modal
            className="signModal"
            // title="Signature"
            closable={false}
            visible={isShow}
            footer={null}
        >
            <div className="signModalTitle">Signature</div>
            <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                <TabPane key="1" tab="Draw">
                    <div className="signModalContent">
                        {!signatureImg && <SignatureCanvas
                            penColor="#000"
                            ref={signatureCanvasRef}
                            canvasProps={{ width: 620, height: 240, className: 'sigCanvas' }} onTouchMove={() => { }}
                        />}
                        {signatureImg && <div className="signImgBox">
                            <img src={signatureImg}></img>
                        </div>}
                        <div className="message">{"By signing this document with an electronic signature. I agree that such signature will be as valid as handwritten signature to the extent allowed by local laws."}</div>
                        <div className="message">{"After signing please submit the WPA Form."}</div>
                        <div className="saveButtonBox">
                            <div className="cancelButton" onClick={() => clearSignature()}>Cancel</div>
                            <div className='websiteSysButtonBox'>
                                <div className="clearButton" onClick={() => clear()}>Clear</div>
                                <div className="submitButton" onClick={() => saveSignature()}>Signature</div>
                            </div>
                        </div>
                    </div>
                </TabPane>
                <TabPane key="3" tab="Upload">
                    <div className="signModalContent">
                        <div className='sysRow'>
                            <div className='sysCol'>
                                <div className="sysParamTitle">Signature Photo</div>
                                <div className="sysInput">
                                    <Modal title="Enlarged View" visible={previewVisible} footer={null} onCancel={handleCancel}>
                                        <img alt="example" style={{ width: '100%' }} src={previewImage} />
                                    </Modal>
                                    <Upload
                                        action={Config.imgUploadServer}
                                        key={"1"}
                                        accept=".png, .jpg, .jpeg"
                                        listType="picture-card"
                                        fileList={imageFile}
                                        onPreview={handlePreview}
                                        onChange={(file) => handleChange(file)}>
                                        {imageFile.length >= imageNum ? null : uploadButton}
                                    </Upload>
                                </div>
                            </div>
                        </div>
                        <div className="message">{"By signing this document with an electronic signature. I agree that such signature will be as valid as handwritten signature to the extent allowed by local laws."}</div>
                        <div className="message">{"After signing please submit the WPA Form."}</div>
                        <div className="saveButtonBox">
                            <div className="cancelButton" onClick={() => clearSignature()}>Cancel</div>
                            <div className="submitButton" onClick={() => saveSignature3()}>Signature</div>
                        </div>
                    </div>
                </TabPane>
            </Tabs>
        </Modal>
    )

}

SignModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    signatureImg: PropTypes.string.isRequired,
}
export default SignModal;